<div class="row" *ngIf="!wrongFilters; else bloccoElse">

  <!-- Energia prodotta BOX 1 -->
  <div class="col-lg-3" *ngIf="!loading; else bloccoLoading">
    <mat-card>
      <mat-card-content style="margin:0 auto;">
        <div class="d-flex align-items-center">
          <div class="m-r-30">
            <i-tabler name="solar-panel" class="icon-50 d-flex" style="color:#5bb700"></i-tabler>
          </div>
          <div>
            <span class="text-uppercase f-s-12" style="color: #5bb700;">Energia prodotta</span>
            <h6 class="text-primary m-0 f-s-18 f-w-400">{{ powerData.prodotta }} kWh</h6>
          </div>
          <div class="d-flex flex-column m-l-8">
            <apx-chart [series]="breadcrumbOption.series" [chart]="breadcrumbOption.chart"
              [dataLabels]="breadcrumbOption.dataLabels" [plotOptions]="breadcrumbOption.plotOptions"
              [yaxis]="breadcrumbOption.yaxis" [legend]="breadcrumbOption.legend" [fill]="breadcrumbOption.fill"
              [stroke]="breadcrumbOption.stroke" [tooltip]="breadcrumbOption.tooltip" [xaxis]="breadcrumbOption.xaxis"
              [grid]="breadcrumbOption.grid">
            </apx-chart>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>


  <!-- Energia consumata BOX 2 -->
  <div class="col-lg-3" *ngIf="!loading; else bloccoLoading">
    <mat-card>
      <mat-card-content style="margin:0 auto;">
        <!-- 2 -->
        <div class="d-flex align-items-center">
          <div class="m-r-30" style="color: orange;">
            <i-tabler name="bolt" class="icon-50 d-flex"></i-tabler>
          </div>
          <div>
            <span class="text-uppercase f-s-12" style="color: orange;">Energia consumata</span>
            <h6 class="text-accent m-0 f-s-18 f-w-400">{{ powerData.consumata }} kWh</h6>
          </div>
          <div class="d-flex flex-column m-l-8">
            <apx-chart [series]="breadcrumb2Option.series" [chart]="breadcrumb2Option.chart"
              [dataLabels]="breadcrumb2Option.dataLabels" [plotOptions]="breadcrumb2Option.plotOptions"
              [yaxis]="breadcrumb2Option.yaxis" [legend]="breadcrumb2Option.legend" [fill]="breadcrumb2Option.fill"
              [stroke]="breadcrumb2Option.stroke" [tooltip]="breadcrumb2Option.tooltip"
              [xaxis]="breadcrumb2Option.xaxis" [grid]="breadcrumb2Option.grid">
            </apx-chart>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- CO2 non immessa BOX 3 -->
  <div class="col-lg-3" *ngIf="!loading; else bloccoLoading">
    <mat-card>
      <mat-card-content style="margin:0 auto;">
        <!-- 3 -->
        <div class="d-flex align-items-center">
          <div class="m-r-30">
            <i-tabler name="leaf" class="icon-50 d-flex" style="color: rgb(0, 119, 255);"></i-tabler>
          </div>
          <div>
            <span class="text-uppercase f-s-12" style="color: rgb(0, 119, 255);">CO2 non immessa</span>
            <h6 class="text-accent m-0 f-s-18 f-w-400">{{ powerData.co2 }} Kg</h6>
          </div>
          <div class="d-flex flex-column m-l-8">
            <apx-chart [series]="breadcrumb2Option.series" [chart]="breadcrumb2Option.chart"
              [dataLabels]="breadcrumb2Option.dataLabels" [plotOptions]="breadcrumb2Option.plotOptions"
              [yaxis]="breadcrumb2Option.yaxis" [legend]="breadcrumb2Option.legend" [fill]="breadcrumb2Option.fill"
              [stroke]="breadcrumb2Option.stroke" [tooltip]="breadcrumb2Option.tooltip"
              [xaxis]="breadcrumb2Option.xaxis" [grid]="breadcrumb2Option.grid">
            </apx-chart>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- PM10 risparmiata BOX 4 -->
  <div class="col-lg-3" *ngIf="!loading; else bloccoLoading">
    <mat-card>
      <mat-card-content style="margin:0 auto;">
        <!-- 3 -->
        <div class="d-flex align-items-center">
          <div class="m-r-30">
            <i-tabler name="leaf" class="icon-50 d-flex" style="color: rgb(0, 119, 255);"></i-tabler>
          </div>
          <div>
            <span class="text-uppercase f-s-12" style="color: rgb(0, 119, 255);">PM10 non immesso</span>
            <h6 class="text-accent m-0 f-s-18 f-w-400">{{ powerData.pm10 }} mg</h6>
          </div>
          <div class="d-flex flex-column m-l-8">
            <apx-chart [series]="breadcrumb2Option.series" [chart]="breadcrumb2Option.chart"
              [dataLabels]="breadcrumb2Option.dataLabels" [plotOptions]="breadcrumb2Option.plotOptions"
              [yaxis]="breadcrumb2Option.yaxis" [legend]="breadcrumb2Option.legend" [fill]="breadcrumb2Option.fill"
              [stroke]="breadcrumb2Option.stroke" [tooltip]="breadcrumb2Option.tooltip"
              [xaxis]="breadcrumb2Option.xaxis" [grid]="breadcrumb2Option.grid">
            </apx-chart>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

</div>

<ng-template #bloccoElse>
  <div class="col-12 text-center f-s-24 f-w-500 p-y-20">
    Parametri di ricerca errati. Nessun dato.
  </div>
</ng-template>

<ng-template #bloccoLoading>
  <div class="col-lg-3">
    <mat-card>
      <mat-card-header>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </mat-card-header>
      <mat-card-content style="margin-top:8px;">
        <ngx-skeleton-loader count="1" appearance="line" animation="progress" [theme]="{
      'background-color': '#e7e7e7',
        height: '15px',
      'border-radius': 0
        }">
        </ngx-skeleton-loader>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>